export const MailBoxEmailList = `query MailBoxEmailList($locationid: ID!, $emailtype: Int, $pagenumber: Int, $pagesize: Int, $searchtext: String, $ordercolumn: String, $status: [Int!], $orderby: String, $startdate: String, $enddate: String, $subject: String, $notSubject: String, $to: String, $fromemail: String, $emailbody: String) {
    mailBoxEmailList(locationid: $locationid, emailtype: $emailtype, pagenumber: $pagenumber, pagesize: $pagesize, searchtext: $searchtext, ordercolumn: $ordercolumn, orderby: $orderby, status: $status, startdate: $startdate, enddate: $enddate, subject: $subject, notSubject: $notSubject, to: $to, fromemail: $fromemail, emailbody: $emailbody) {
      count
      rows {
        emailid
        to
        cc
        source
        fromemail
        fromname
        subject
        emailbody
        status
        scheduledatetime
        contactid
        servicesprovider
        emailtype
        parentemailid
        replies {
          emailid
          to
          cc
          fromemail
          fromname
          subject
          emailbody
          emailattachments
          status
          scheduledatetime
          contactid
          servicesprovider
          emailtype
          parentemailid
          servicesproviderid
        }
        contact {
          contactid
          primaryemail
          firstname
          lastname
          status
        }
      }
    }
  }`;

export const SyncMailBox = `query Query($locationid: ID!) {
  syncMailboxEmails(locationid: $locationid)
}`;

export const SyncCampaignEmail = `mutation SyncCampaignEmail($ownerid: ID!, $locationid: ID!) {
  syncCampaignEmail(ownerid: $ownerid, locationid: $locationid)
}`